import {Component, OnInit, Input, ViewChild} from '@angular/core';
import {Router} from "@angular/router";
import { GenericConfig} from "@signature-it/ngx-generic/config";
import {PageNotificationService} from "@signature-it/ngx-generic/services";
import {TranslateService} from "@ngx-translate/core";
import { TemplateRef } from '@angular/core';
import {MatDialogRef, MatDialog} from "@angular/material/dialog";
declare var sessionStorage: any;

@Component({
    selector: 'add-to-compare',
    templateUrl: './add-to-compare.html',
    styleUrls: ['./add-to-compare.scss'],
    standalone: false
})
export class AddToCompareComponent_Generic implements OnInit{

    @Input() productId: number;
    @Input() page: string;
    @ViewChild('compareDialog') compareDialog: TemplateRef<any>;
    dialogRef: MatDialogRef<any, any>;

    compareProduct: boolean = GenericConfig.compareProduct == false ? false: true;

    public compare: any = {};
    public comparePage: boolean = false;
    protected compareData = JSON.parse(sessionStorage.getItem('compareData'));

    constructor(
                public notifySvc: PageNotificationService,
                protected translateSvc: TranslateService,
                private router: Router,
                public dialog: MatDialog,
                ) {
    }

    ngOnInit(){
        this.productId = Number(this.productId)
        if (this.router.url.includes('compare-products')) {
            this.comparePage = true;
        }

        if (this.compareData && this.compareData.ids && this.compareData.ids.length > 0) {
            this.compare = {};
            for (let value of this.compareData.ids) {
                this.compare[value] = true;
            }
        }
    }

    addToCompare(id) {
        this.compareData = JSON.parse(sessionStorage.getItem('compareData'));
        if (this.compareData && this.compareData.ids && this.compareData.ids.length > 2 && !this.compare[id]) {
        this.dialogRef = this.dialog.open(this.compareDialog, { });
            //this.notifySvc.set(this.translateSvc.instant("can't compare more than 3 products"), 400).show();
        } else {
            if (this.compare[id] == null) {
                this.compare[id] = true;
            } else {
                this.compare[id] = !this.compare[id]
            }
            if (this.compare[id]) {
                if (this.compareData && this.compareData.ids) {

                    this.compareData.ids.push(id);
                    sessionStorage.setItem('compareData', JSON.stringify(this.compareData));
                } else {
                    this.compareData = {};
                    this.compareData.ids = [];
                    this.compareData.ids.push(id);
                    sessionStorage.setItem('compareData', JSON.stringify(this.compareData));
                }
            } else if (this.compare[id] === false) {
                let idIndex = this.compareData.ids.indexOf(id);
                if (this.compareData && this.compareData.ids && idIndex !== -1) {
                    this.compareData.ids.splice(idIndex, 1);
                    sessionStorage.setItem('compareData', JSON.stringify(this.compareData));
                }
            }
        }
    }

    removeFromCompare(id) {
        let idIndex = this.compareData.ids.indexOf(id);
        if (this.compareData && this.compareData.ids && idIndex !== -1) {
            this.compareData.ids.splice(idIndex, 1);
            sessionStorage.setItem('compareData', JSON.stringify(this.compareData));
        }
        window.location.reload();
    }

}
